import { FC, useState } from 'react';
import { useIntl } from 'react-intl';

import { useAppDispatch } from '@/shared/hooks';
import { Modal, ModalProps } from '@/shared/ui';

import { accessModel } from '@/entities/access';
import { organizationStaffModel } from '@/entities/organizationStaff';

type RemoveStaffMemberModalProps = {
  className?: string;
  testID?: string;
  deletingUserId: string;
} & Pick<ModalProps, 'isOpen' | 'onCancel'>;

export const RemoveStaffMemberModal: FC<RemoveStaffMemberModalProps> = (
  props,
) => {
  const {
    className,
    testID,
    isOpen,
    onCancel: onCancel,
    deletingUserId,
  } = props;
  const dispatch = useAppDispatch();

  const [isDeleting, setIsDeleting] = useState(false);

  const { formatMessage } = useIntl();

  const handleDeleteStaffMember = async () => {
    setIsDeleting(true);
    try {
      const { OrganizationStaff: removedStaff } = await dispatch(
        accessModel.thunks.removeOrganizationStaff({
          StaffID: deletingUserId,
        }),
      ).unwrap();

      if (removedStaff) {
        dispatch(organizationStaffModel.actions.setNewestOne(removedStaff));
      }
    } finally {
      setIsDeleting(false);
      if (onCancel) {
        onCancel();
      }
    }
  };

  return (
    <Modal
      data-component="remove-staff-member-modal"
      className={className}
      data-testid={testID}
      title={formatMessage({
        id: 'removeStaffMemberModal.title',
        defaultMessage: 'Remove this staff member?',
      })}
      isOpen={isOpen}
      onCancel={onCancel}
      onOk={handleDeleteStaffMember}
      okButtonText={formatMessage({
        id: 'global.applyRemove',
        defaultMessage: 'Yes, remove',
      })}
      okButtonProps={{
        danger: true,
        loading: isDeleting,
      }}
    />
  );
};
